/**
 * Default external API
 */

import {default as ExternalAPI} from './API';

export default ExternalAPI;